import { all, takeLatest, put } from 'redux-saga/effects'

import * as aiActions from '../actions'
import * as notificationActions from '../../notification/actions'

function* onUpdateUniqueAiObjectSuccess(action) {
  if (!action.payload.suppressNotification) {
    yield put(notificationActions.onAddInfoNotification({ message: 'Properties successfully updated' }))
  }
}

function* onUpdateUniqueAiObjectFailed(action) {
  if (!action.payload.suppressNotification) {
    yield put(notificationActions.onAddErrorNotification({ message: 'Failed to update the object.' }))
  }
}

function* updateUniqueAIObject() {
  yield all([
    takeLatest(aiActions.updateUniqueAiObjectSuccess, onUpdateUniqueAiObjectSuccess),
    takeLatest(aiActions.updateUniqueAiObjectFailed, onUpdateUniqueAiObjectFailed),
  ])
}

export default updateUniqueAIObject
